import {createEntityService} from "base/entity/service";
import {
    regions_api_adapter,
    regions_api_list_adapter,
    createRegions,
    createRegionsList,
} from "./Regions";
import {Service as DefaultService} from "app/common/service";

const entityService = createEntityService(
    "/api/app/regions",
    createRegions,
    createRegionsList,
    regions_api_adapter,
    regions_api_list_adapter
);

export const RegionsService = DefaultService(entityService);
